export const pageview = () => {
  window.ttq.track('ViewContent')
}

export const event = (name, options = {}) => {
  window.ttq.track(name, options)
}
